console.log("sasayaca contact js asset");
productRadio = document.getElementById("product-radio");
dealRadio = document.getElementById("deal-radio");
otherRadio = document.getElementById("other-radio");
companyInput = document.getElementById("company-input");
urlInput = document.getElementById("url-input");

console.log(productRadio, dealRadio, otherRadio);

productRadio.onchange = function () {
	if (this.checked) {
		console.log("product - checked");
		companyInput.classList.add("d-none");
		urlInput.classList.add("d-none");
	}
};
dealRadio.onchange = function () {
	if (this.checked) {
		companyInput.classList.remove("d-none");
		urlInput.classList.remove("d-none");
	}
};

otherRadio.onchange = function () {
	if (this.checked) {
		companyInput.classList.add("d-none");
		urlInput.classList.add("d-none");
	}
};
